var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarListeningTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99972 1.14075C4.21222 1.14075 1.14258 4.21039 1.14258 7.99789V14.4265C1.14258 14.664 1.33365 14.855 1.57115 14.855H4.85686C5.48722 14.855 5.99972 14.3425 5.99972 13.7122V9.99789C5.99972 9.36753 5.48722 8.85503 4.85686 8.85503H2.42829V7.99789C2.42829 4.92111 4.92294 2.42646 7.99972 2.42646C11.0765 2.42646 13.5712 4.92111 13.5712 7.99789V8.85503H11.1426C10.5122 8.85503 9.99972 9.36753 9.99972 9.99789V13.7122C9.99972 14.3425 10.5122 14.855 11.1426 14.855H14.4283C14.6658 14.855 14.8569 14.664 14.8569 14.4265V7.99789C14.8569 4.21039 11.7872 1.14075 7.99972 1.14075ZM4.71401 10.1407V13.5693H2.42829V10.1407H4.71401ZM13.5712 13.5693H11.2854V10.1407H13.5712V13.5693Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarListeningTest);
export default __webpack_public_path__ + "static/media/sidebar-listening-test.e8b035d83ada4dae38ad2cd095809e7c.svg";
export { ForwardRef as ReactComponent };